import React from 'react';
import { useTranslation } from 'react-i18next';

import { OpenClassSession } from '../types/OpenClass';
import { sortSessionsByStart } from '../utils/openClass';

const SessionCapacityList: React.FC<{ sessions: OpenClassSession[] }> = ({
  sessions,
}) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-1">
      {sortSessionsByStart(sessions).map((session, index) => (
        <div key={session.id} className="whitespace-nowrap">
          {session.assignedSeatCount ?? '–'} / {session.capacity}
          <span className="ml-2 text-xs text-blueGrayDark">
            {t('views.OpenClasses.sessionNumber', { number: index + 1 })}
          </span>
        </div>
      ))}
    </div>
  );
};

export default SessionCapacityList;
